const ns = "PASSES_CHECKIN";
export const RECEIVE_PAGINATION = `${ns}_RECEIVE_PAGINATION`;
export const RECEIVE_LIST = `${ns}_RECEIVE_LIST`;
export const RECEIVE_COUNTS = `${ns}_RECEIVE_COUNTS`;
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE_RECORD_WITH_ISSUANCE = `${ns}_RECEIVE_RECORD_WITH_ISSUANCE`;
export const INVALIDATE_RECORD_WITH_ISSUANCE = `${ns}_INVALIDATE_RECORD_WITH_ISSUANCE`;
